<template>
  <ResendMeasureToApprovationModal
    v-if="showResendMeasureToApprovationModal"
    :measureId="measure.id"
    @closeModal="closeModal"
  />
  <div
    class="card card-body border-start border-start-width-2 border-start-primary"
  >
    <div class="row">
      <div class="col-sm-6">
        <p><strong>Fornecedor:</strong> {{ measure.providerName }}</p>
      </div>
      <div class="col-sm-6">
        <p><strong>Tipo da Medição:</strong> {{ measure.type }}</p>
      </div>
    </div>
    <hr class="mt-2" />
    <h5 class="text-center">Realizar Medição</h5>
    <InfoMeasureItens
      :noteValue="parseFloat(measure.noteValue)"
      :noteValueNet="parseFloat(measure.noteValueNet)"
      :xmlJustify="measure.xmlJustify"
    />
    <ItensMeasure :measure="measure" @getMeasure="getMeasure" />
  </div>
  <AttachsMeasure :measure="measure" @getMeasure="getMeasure" />
  <div
    v-if="measure.status === MeasureStatusEnum.REPROVADO"
    class="card card-body border-start border-start-width-2 border-start-danger"
  >
    <div class="alert alert-danger">
      <strong>Medição reprovada: </strong>{{ measure.reprovationJustify }}
    </div>
    <div class="text-center">
      <button
        class="btn btn-yellow rounded-pill"
        title="Reenviar para Aprovação"
        @click="showResendMeasureToApprovationModal = true"
      >
        Reenviar para Aprovação
      </button>
    </div>
  </div>
</template>

<script>
import ResendMeasureToApprovationModal from '@/components/documents/measures/ResendMeasureToApprovationModal.vue'
import InfoMeasureItens from '@/components/documents/commons/InfoMeasureItens.vue'
import ItensMeasure from '@/components/documents/measures/ItensMeasure.vue'
import AttachsMeasure from '@/components/documents/measures/AttachsMeasure.vue'
import MeasureStatusEnum from '@/enum/measureStatusEnum'

export default {
  name: 'EditMeasure',

  props: {
    measure: {
      type: Object,
      required: true,
    },
  },

  components: {
    ResendMeasureToApprovationModal,
    InfoMeasureItens,
    ItensMeasure,
    AttachsMeasure,
  },

  emits: ['getMeasure'],

  data() {
    return {
      showResendMeasureToApprovationModal: false,
      MeasureStatusEnum,
    }
  },

  methods: {
    closeModal(reloadMeasure) {
      if (reloadMeasure) {
        this.getMeasure()
      }
      this.showResendMeasureToApprovationModal = false
    },

    getMeasure() {
      this.$emit('getMeasure')
    },
  },
}
</script>
